<template src="./Icon.html"></template>
<style lang="scss" src="./Icon.scss"></style>

<script>
	export default {
		props: {
			type: {
				type: String
			},
			color: String
		}
	};
</script>
